/**
 * @file Category.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Service from './Service'
import services from '../components/http/request'


const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

class Setting extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
  }

  /**
   * Get Settings
   *
   * @async
   * @function getSettings
   * @param {string} ckey
   * @return {Promise<json>} The json with the result
   */
  async getSettings(key) {
    return new Promise((resolve, reject) => {
      if (typeof key === 'undefined') reject("Esperado o identificador do key");
      let endPoint = `/api/0.1-a/ProxyPostgRest/api/tbSetting?cKey=eq.${key}`
      let request = new services({tag: 'das'});
      request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }
}
export { Setting}
